import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import baseURL from "../../config";

const CrewContractSection = ({ contractData }) => {
  if (!contractData.length) {
    return <Typography align="center">No contract details available.</Typography>;
  }

  return (
    <Box sx={{ p: 2 }}>
      <TableContainer component={Paper} elevation={3}>
        <Table>
          <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
            <TableRow>
              <TableCell><strong>Sr. No.</strong></TableCell>
              <TableCell><strong>Vessel Details</strong></TableCell>
              <TableCell><strong>Crew Details</strong></TableCell>
              <TableCell><strong>Form I</strong></TableCell>
              {/* <TableCell><strong>Crewing Agent</strong></TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {contractData.map((contract, index) => (
              <TableRow key={contract._id}>
                <TableCell>{index + 1}</TableCell>

                <TableCell>
                  <Typography><strong>Vessel:</strong> {contract.ShipDetails?.vesselname || "N/A"}</Typography>
                </TableCell>

                <TableCell>
                  <Typography><strong>Name:</strong> {contract.crewdetails?.name || "N/A"}</Typography>
                  <Typography><strong>Indos No.:</strong> {contract.crewdetails?.indosno || "N/A"}</Typography>
                  <Typography><strong>Email:</strong> {contract.crewdetails?.email || "N/A"}</Typography>
                  <Typography><strong>Passport:</strong> {contract.crewdetails?.passport || "N/A"}</Typography>
                  <Typography><strong>Rank:</strong> {contract.rank?.rankname || "N/A"}</Typography>
                </TableCell>

                <TableCell>
                  {contract?.formI?.filePath ? (
                    <Tooltip title={contract.formI?.originalName || "View PDF"}>
                      <IconButton
                        href={`${baseURL}/${contract.formI.filePath.replace(/\\/g, "/")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <PictureAsPdfIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Typography>No file uploaded</Typography>
                  )}
                </TableCell>


                {/* Optional: <TableCell>{contract.crewingAgent?.agentName || "N/A"}</TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CrewContractSection;
